import { render, staticRenderFns } from "./PickupModal.vue?vue&type=template&id=2d1342ae&scoped=true"
import script from "./PickupModal.vue?vue&type=script&lang=ts"
export * from "./PickupModal.vue?vue&type=script&lang=ts"
import style0 from "./PickupModal.vue?vue&type=style&index=0&id=2d1342ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1342ae",
  null
  
)

export default component.exports